import {
  Stack,
  Heading,
  Text,
  Actions,
  ButtonLink,
  Strong,
} from 'braid-design-system';

import Routes from 'src/config/routes';
import { createEditListingUrl } from 'src/utils';

interface GenericRepostSuccessProps {
  clientId: string;
  listingId: string;
}

export const GenericRepostSuccess = (props: GenericRepostSuccessProps) => (
  <Stack space="large">
    <Heading level="3" component="h1">
      Repost successful
    </Heading>

    <Stack space="large">
      <Text>Your ad is now live - nice one!</Text>

      <Text data={{ testid: 'generic-repost-payment-success-tip' }}>
        <Strong>Tip:</Strong> Buyers are more likely to respond to well-written,
        detailed ads. Want to check your listing description while you&apos;re
        here?
      </Text>
    </Stack>

    <Actions>
      <ButtonLink
        href={createEditListingUrl(props.clientId, props.listingId)}
        tone="formAccent"
      >
        Edit ad
      </ButtonLink>
      <ButtonLink href={Routes.DASHBOARD} variant="soft">
        Return to dashboard
      </ButtonLink>
    </Actions>
  </Stack>
);
